// removed by extract-text-webpack-plugin
module.exports = {"dialog":"theme__dialog___1f3Zg","active":"theme__active___3rz6t","small":"theme__small___WKoav","normal":"theme__normal___1WehK","large":"theme__large___10bxm","fullscreen":"theme__fullscreen___2Akul","title":"theme__title____sEzV","body":"theme__body___1_nNM","navigation":"theme__navigation___3eiS-","button":"theme__button___3HGWm"};


//////////////////
// WEBPACK FOOTER
// ./~/react-toolbox/lib/dialog/theme.scss
// module id = 1209
// module chunks = 0